import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import type { GeneralResp } from '@/models/GeneralResp';
import type { ClientUploadResult } from '@/models/ClientUploadResult';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 客戶上傳單一檔案請求參數
 */
export interface IClientUploadSingleFileParams {
    /** 上傳檔案內容 (Base64) */
    fileBase64Content: string;
    /** 關聯的上傳項目ID (第2層項目) */
    itemID: number;
    /** 檔案Mime Type */
    mimeType: string;
    /** 已上傳檔案fileHash */
    fileHash: string;
}

/**
 * 客戶上傳單一檔案回應
 */
export interface IClientUploadSingleFileResponse extends GeneralResp {
    /** 上傳成功後的結果 */
    result: ClientUploadResult | null;
}

/**
 * Client - 客戶上傳單一檔案 API (身分證正面以外的一般文件)
 *
 * @description 客戶上傳單一檔案，不包含身分證正面文件
 * @param params 上傳檔案請求參數
 * @returns Promise<IClientUploadSingleFileResponse>
 */
export async function ClientUploadSingleFile(params: IClientUploadSingleFileParams): Promise<IClientUploadSingleFileResponse> {
    const url = RouteUrlList.API_ClientUploadSingleFile.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.false,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(url, params, config).then((res: AxiosResponse<IClientUploadSingleFileResponse>) => {
        return res.data;
    });
}

export default ClientUploadSingleFile;
